import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
var __jsx = React.createElement;
import React from "react";
export default function ELSCSSGrid(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  // Column Size (col-1, col-2, col-3, col-4, col-5, col-6) - Columns default to equal size columns aross the parent container and currently
  // just using col-6 based on our currently designs.  If need for more such as col-7 or col-8, please request and we can look into.

  // Use individual page .scss file to manipulatethe column spacing to fit your design requirements until we can figure out
  // how to implement a more robust column width mechanism.

  // So for example: to make a 4 column layout  (Each column will be 3 columns out of 12 column base layout)
  // you would pass:
  // <ELSCSSGrid className="col-4" id={styles["additional_classYouWant"]}>
  //     <ELSCSSGridItem>Column 1</ELSCSSGridItem>
  //     <ELSCSSGridItem>Column 2</ELSCSSGridItem>
  //     <ELSCSSGridItem>Column 3</ELSCSSGridItem>
  //     <ELSCSSGridItem>Column 4</ELSCSSGridItem>
  // </ELSCSSGrid>
  // This will create a 4 column layout with each column equal size - sizing aka column widthc can be overridden in that particular page using classes
  // PLEASE see CSSGrid.scss for more on column sizing

  return /*#__PURE__*/React.createElement("section", _extends({
    className: "grid__container ".concat(className || "")
  }, props), props.children);
}